import { render } from "./ChoiceToggle.vue?vue&type=template&id=6f15ddfa&scoped=true&ts=true"
import script from "./ChoiceToggle.vue?vue&type=script&lang=ts"
export * from "./ChoiceToggle.vue?vue&type=script&lang=ts"

import "./ChoiceToggle.vue?vue&type=style&index=0&id=6f15ddfa&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6f15ddfa"]])

export default __exports__